import React, { useEffect } from 'react'
import ContactForm from './ContactForm'
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import { Helmet } from 'react-helmet';
import {URL} from '../Variables'
import ReactGA from 'react-ga';
import { useTranslation } from 'react-i18next';
const Contact = () => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  const {t} = useTranslation();
  return (
    <>
    <Helmet>
      <title>{t('breadcrumb.CONTACT')}</title>
      <meta
          name="description"
          content="Landes Location"
          />
          <link rel="canonical" href={`${URL}/contact`} />
          <script type="application/ld+json">
            {`
 {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Contact",
  "url": "${URL}/contact",
  "description": "page de contact"
}
`}
          </script>
    </Helmet>
    <Breadcrumbs  path={`/${t('breadcrumb.CONTACT')}`}/>
    <div className='Contact-container row m-0'>
     
      <ContactForm/>
    </div>
    </>
  )
}
export default Contact
